import { mapColorsToScheme } from '../../../../lib';
import { pxToRem } from '../../utils';
var colorVariant = 500;
export default (function (siteVars) { return ({
    colors: mapColorsToScheme(siteVars, colorVariant),
    color: undefined,
    backgroundColor: undefined,
    borderColor: undefined,
    brandColor: siteVars.brandColor,
    secondaryColor: siteVars.white,
    redColor: siteVars.red,
    disabledColor: siteVars.gray06,
    horizontalSpace: pxToRem(10),
    margin: "0 " + pxToRem(8) + " 0 0",
    outline: undefined,
}); });
